export default __webpack_public_path__ + "static/media/last-position-truck.c857a6db.png";